// state
import axios from "axios";

const defaultState = () => ({
  oldPassword: null,
  newPassword: null,
  confirmNewPassword: null
});

const state = defaultState();
// getters
const getters = {};

// actions
const actions = {
  save({ state }) {
    return new Promise((resolve, reject) => {
      axios
        .post("/changepassword", state)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

// mutations
const mutations = {
  RESET(state) {
    Object.assign(state, defaultState());
  },
  SET_CHANGEPASSWORD_DATA(state, data) {
    if (Object.prototype.toString.call(state[data.key]) === "[object Array]") {
      state[data.key][data.index][data.property] = data.value;
    } else if (
      Object.prototype.toString.call(state[data.key]) === "[object Object]"
    ) {
      state[data.key][data.property] = data.value;
    } else state[data.key] = data.value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
